<template>
  <div class="h-100 d-flex flex-column">
    <DataLoader v-if="loading"/>
    <div class="container text-center" v-if="!loading">
      <div class="row pt-4 pb-3">
        <div class="col-sm">
          <svg width="51px" height="40px" viewBox="0 0 51 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="ускорение" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Desktop_07" transform="translate(-455.000000, -332.000000)" stroke="#FFFFFF" stroke-width="5">
                <g id="Group" transform="translate(323.000000, 334.000000)">
                  <polyline id="Path-3" points="134 21.0689731 146.950031 34 181 0"></polyline>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-sm">
          <h1>Спасибо</h1>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm">
          <h3>Оплата прошла успешно!</h3>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm">
          <h3>Ваш промокод <br><b>{{ this.promocode }}</b></h3>
         <h4>Обязательно сохраните этот код. Мы также отправим его на ваш email.</h4>
          <h4>VIP статус действует
            до <b>{{ this.vipDate }}</b></h4>
        </div>
      </div>
    </div>
    <button type="button" v-if="!loading" @click="$router.push('/')"
            class="btn btn-light btn-own mt-auto mb-4 align-self-center ">Вернуться на главную
    </button>
    <!--  <div v-if="!loading"  class="container " ></div>-->
  </div>
</template>

<script>
import DataLoader from '@/components/DataLoader'
import axios from 'axios'

export default {
  name: 'SuccessPayment',
  components: { DataLoader },
  data () {
    return {
      vipDate: '**-**-****',
      promocode: '---',
      loading: true
    }
  },
  mounted () {
    let promocode
    if (typeof this.$route.params.code !== 'undefined') {
      promocode = this.$route.params.code
    } else {
      if (typeof localStorage.promocode !== 'undefined') {
        promocode = localStorage.promocode
        this.$router.push('/success-paymant/' + promocode)
        // window.location.replace(response.data.payment_url)
      } else {
        promocode = ''
      }
    }
    axios
      .get('https://api.stl-vpn.ru/tinkoff/last-order-info?code=' + promocode)
      .then(response => {
        const data = response.data
        this.vipDate = data.vipDate
        this.promocode = data.promocode
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => (this.loading = false))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container.success {
  height: 300px;
  background: rgba(40, 240, 40, 0.5);
  border: 1px #e6e7ec solid;
}

.success-text {
  align-self: center;
  text-align: left;
  width: 100%;
}

.success-text p {
  font-size: 14px;
  line-height: 14px;
}

@media (max-width: 767px) {
  .container.success {
    height: 370px;
    background: none;
    border: none;
  }

  .success-text {
    text-align: center;
  }

}
</style>
